import { render, staticRenderFns } from "./MessagePreview.vue?vue&type=template&id=37338744&scoped=true"
import script from "./MessagePreview.vue?vue&type=script&lang=js"
export * from "./MessagePreview.vue?vue&type=script&lang=js"
import style0 from "./MessagePreview.vue?vue&type=style&index=0&id=37338744&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "37338744",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\a\\1\\s\\Generac.Application.MobileLink\\ClientApp\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('37338744')) {
      api.createRecord('37338744', component.options)
    } else {
      api.reload('37338744', component.options)
    }
    module.hot.accept("./MessagePreview.vue?vue&type=template&id=37338744&scoped=true", function () {
      api.rerender('37338744', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/MessageCenter/MessagePreview.vue"
export default component.exports